<template>
    <div>
        <modal :close="closeModal" :show="value">
            <template v-slot:header>
                <h1 class="header">There was an error with your Bank Card</h1>
            </template>

            <template v-slot:body>
                <div class="body-text">
                    <strong v-if="errorRetryMessage">{{ errorRetryMessage }}</strong>
                    <strong v-else>Please make sure your information is correct, or try a different bank card.</strong>
                </div>
            </template>

            <template v-slot:footer>
                <div class="text-right">
                    <button class="confirm-button" @click="closeModal()">Okay</button>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
    import Modal from "../../modal/Modal.vue"

    export default {
        name: "HfdBankCardErrorModal",
        components: {
            Modal,
        },
        props: {
            value: {
                type: Boolean,
                default: false,
            },
            errorRetryMessage: {
                type: String,
                default: "",
            },
        },
        methods: {
            closeModal() {
                this.$emit("close-modal", true)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .overflow-hidden {
        overflow: hidden;
    }

    .header {
        padding-top: to_rem(24px);
        padding-bottom: to_rem(16px);
        font-style: normal;
        font-weight: 600;
        font-size: to_rem(26px);
        line-height: to_rem(32px);
        letter-spacing: -0.5px;
        color: $primary-color;
    }

    .body-text {
        font-weight: 400;
        font-size: to_rem(18px);
        color: $grey-darken-2;
        line-height: to_rem(28px);
    }

    .confirm-button {
        font-size: to_rem(18px);
        margin: 0px 8px;
        height: 20px;
        color: $secondary-color;
        font-weight: bold;
    }
</style>
